import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = [ "Explore the Power", "Discover the Impact" ];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])

// Slick 设置
const settings = {
  dots: true,             // 显示小圆点
  infinite: true,         // 无限循环
  speed: 500,             // 切换速度
  slidesToShow: 3,        // 同时显示几张卡片
  slidesToScroll: 1,      // 每次滚动一张
  swipeToSlide: true,     // 允许拖拽滑动
  draggable: true,        // 启用鼠标拖动
  responsive: [
    {
      breakpoint: 1024,   // 在宽度 <=1024 时
      settings: {
        slidesToShow: 2,  // 显示2张
      }
    },
    {
      breakpoint: 600,    // 宽度 <=600 时
      settings: {
        slidesToShow: 1,  // 显示1张
      }
    }
  ]
}


  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                {/* <span className="tagline">Welcome to my Portfolio</span> */}
                <h1><span className="txt-rotate" dataPeriod="1000" data-rotate='[ "Explore the Power", "Discover the Impact "]'><span className="wrap">{text}</span></span>{` of Influencer Marketing`} </h1>
                  <p>We 
continuously create change in the digital world through social media management,
influencer marketing, and event marketing services!</p>
                  {/* <button onClick={() => console.log('Connect')}>Let’s Connect <ArrowRightCircle size={25} /></button> */}
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <div className="section-divider"></div>
    </section>
  )
}
